<template>
    <tr>
        <td> {{ item.date }}</td>
        <td> {{ item.bill_number }}</td>
        <td class="text-right"> {{ item.total_amount }}</td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.vds_payable_amount"
                :disabled="item.is_bill_tds_vds || item.is_tds_vds_adjusted"
                :readonly="isDisabled"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.tds_payable_amount"
                :disabled="item.is_bill_tds_vds || item.is_tds_vds_adjusted"
                :readonly="isDisabled"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.discount_receipt_amount"
                :readonly="isDisabled"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right"> {{ item.paid_amount }}</td>
        <td class="text-right"> {{ item.adjustment_amount }}</td>
        <td class="text-right">
            <div class="d-flex align-items-center justify-content-end gap-1">
                <span>{{ commaFormat(getDue) }}</span>
                <span
                    v-if="!isDisabled"
                    class="cursor-pointer"
                    :style="{ color: isSelected ? '#28a745' : '#b0b0b0' }"
                    @click="toggleSelect"
                >
                    <i class="fas fa-check-circle"></i>
                </span>
            </div>
        </td>
        <td class="text-right">
            <div class="d-flex justify-content-end">
                <input
                    v-model="item.payment"
                    @input="checkInputValidity"
                    :readonly="isDisabled"
                    type="number" class="form-control text-right"
                    style="width: 100px"
                >
            </div>
        </td>
    </tr>
</template>

<script setup>
import {computed, ref} from "vue";
import figureFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
    item: Object,
    isDisabled: {
        type: Boolean,
        default: false
    }
})
const {commaFormat} = figureFormatter()
const isSelected = ref(false)

function toggleSelect () {
    isSelected.value = ! isSelected.value
    if (! isSelected.value) {
        props.item.payment = ''
        return
    }
    props.item.payment = getDue.value
}

function checkInputValidity (e) {
    if(e.target.value > props.item.due) {
        props.item.payment = props.item.due
    }
}

const getDue = computed(() => {
  const vdsValue = props.item.vds_payable_amount ? props.item.vds_payable_amount : 0;
  const aitValue = props.item.tds_payable_amount ? props.item.tds_payable_amount : 0;
  const discountValue = props.item.discount_receipt_amount ? props.item.discount_receipt_amount : 0;
  return props.item.due = props.item.total_amount - props.item.adjustment_amount - (vdsValue + aitValue + discountValue + props.item.paid_amount);
})
</script>
